const APP_LOGIN_URL = "https://app.shuttleops.com/login";

export const CAMPAIGN_QUERY_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "marketing_path",
];

export const getAppLoginUrl = (search = globalThis.location?.search ?? "") => {
  const appUrl = new URL(APP_LOGIN_URL);
  const sourceParams = new URLSearchParams(search);

  CAMPAIGN_QUERY_PARAMS.forEach((param) => {
    if (sourceParams.has(param)) {
      appUrl.searchParams.set(param, sourceParams.get(param));
    }
  });

  return appUrl.toString();
};
